import React from "react";

import Header from "../../components/Header";
import { Button } from "primereact/button";

import "./styles.css";

import {Context} from "../../AppProvider";
import { useHistory } from "react-router-dom";
import { isRespondido, isAtivo } from "../../components/Questionarios/listaQuestionarios";

const ICON_SIZE = '2em';

function TelaInicial(props) {
  const history = useHistory();

  return (
    <Context.Consumer>
      {(context) => (
        <>
          <Header videoajuda={props.videoajuda} usuario={context.usuario} />
          <div className="inicial">
            <div className="p-d-flex p-dir-col p-mr-1 p-ml-1 p-justify-end">
              {renderButtonQuestionarios(context.questionarios, history)}
              {renderButtonPaineisApropriadores(context.paineis, history)}
            </div>
          </div>
        </>
      )}
    </Context.Consumer>
  );
}

function renderButtonQuestionarios(questionarios, history) {
  let count = 0;
  if (questionarios !== undefined) {
    count = questionarios.filter(questionario => !isRespondido(questionario) && isAtivo(questionario));
    if (count !== undefined) {
      count = count.length;
    }
  }
  return (
    <Button className="p-col p-mb-2 p-button-lg"
      label="QUESTIONÁRIOS"
      icon={<i className="pi pi-question" style={{ 'fontSize': ICON_SIZE }} />}
      badge={count}
      tooltip={(count > 0)? `Há ${count} questionário(s) para responder.`: null}
      tooltipOptions={{position: 'top'}}
      onClick={() => { history.push('/questionarios') }} />
  );
}

function renderButtonPaineisApropriadores(paineis, history) {
  if(paineis !== null && paineis !== undefined && paineis.length > 0){
    return (
      <Button className="p-col p-mb-2 p-button-lg"
        label="PAINÉIS DE AÇÕES DE MELHORIA"
        icon={<i className="pi pi-sitemap" style={{ 'fontSize': ICON_SIZE }} />}
        onClick={() => { history.push('/paineisapropriadores') }} />
    );
  }
}

export default TelaInicial;